// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__MjS6Z","footerText":"Footer_footerText__RpNsU"};